import api from "@/api";

const namespaced = true

const state = {
  qctseData: {}
}

const getters = {
  qctseData: (state) => state.qctseData
}

const mutations = {
  SET_QCTSE_DATA: (state, payload) => {
    state.qctseData = payload
  }
}

const actions = {
  async fetchBargeMeasurementPerformance({ commit }, payload) {
    try {
      const { data } = await api.getBargeMeasurementPerformance(payload)

      if (data.error) {
        commit('SET_QCTSE_DATA', {})
        return
      }

      commit('SET_QCTSE_DATA', data)
    } catch (err) {
      throw err
    }
  }
}

export default { namespaced, state, getters, mutations, actions }